import { render } from "./QuotationFunctionCard.vue?vue&type=template&id=54a1efe8"
import script from "./QuotationFunctionCard.vue?vue&type=script&lang=js"
export * from "./QuotationFunctionCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__